import yup from '@/init/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { InferType } from 'yup';

export const SearchHospitalNameSchema = yup.object({
  portal_office_name: yup.string(),
  medical_institution_code: yup.string(),
});

export type SearchHospitalNameType = InferType<typeof SearchHospitalNameSchema>;
export const SearchHospitalNameResolver = yupResolver(SearchHospitalNameSchema);
